// src/components/blog/BlogSidebar.jsx

import React, { memo } from 'react';
import BlogSearch from './BlogSearch';
import BlogCategories from './BlogCategories';
import BlogRecentPosts from './BlogRecentPosts';
import BlogTags from './BlogTags';

const BlogSidebar = memo(({
  searchQuery,
  onSearchChange,
  searchResultCount,
  categories,
  activeCategory,
  onCategoryChange,
  recentPosts,
  tags,
  activeTag,
  onTagClick,
  isDark,
  onImageError
}) => {
  return (
    <div className="lg:col-span-1 order-2 lg:order-1">

      {/* Search */}
      <div className={`mb-8 p-4 rounded-xl ${
        isDark
          ? 'bg-white/5 border border-white/10'
          : 'bg-white border border-gray-200'
      }`}>
        <BlogSearch 
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          isDark={isDark}
          resultCount={searchResultCount}
        />
      </div>

      {/* Categories */}
      <BlogCategories 
        categories={categories}
        activeCategory={activeCategory}
        onCategoryChange={onCategoryChange}
        isDark={isDark}
      />

      {/* Recent Posts */}
      <BlogRecentPosts 
        posts={recentPosts}
        isDark={isDark}
        onImageError={onImageError}
      />

      {/* Tags */}
      <BlogTags 
        tags={tags}
        activeTag={activeTag}
        onTagClick={onTagClick}
        isDark={isDark}
      />

    </div>
  );
});

BlogSidebar.displayName = 'BlogSidebar';

export default BlogSidebar;